
import { RegistrationSectionContext } from './Context';

export const RegistrationSectionProvider = ({ children, boxItem:content, nextSlug, sessionInfo, planInfo }) => {
  return (
    <RegistrationSectionContext.Provider value={{ content, nextSlug, sessionInfo, planInfo }}>
      {children}
    </RegistrationSectionContext.Provider>
  );
};
